import React from "react";
import Link from "next/link";
import { Container, Button } from "components";
import { BORDER_RADIUS, COLOR } from "constants/styles";
import { routes } from "utils/routes";

const BillingAddressRequiredBanner = () => {
  return (
    <>
      <style jsx>{`
        .require-billing-info {
          display: flex;
          flex-direction: column;
          align-items: center;
          background: ${COLOR.BG_WHITE};
          border-radius: ${BORDER_RADIUS.PRIMARY};
          padding: 36px;
          color: ${COLOR.TEXT_PRIMARY};
          align-self: baseline;
          box-shadow: rgb(26 108 225 / 10%) 0px 0px 25px;
          max-width: 480px;
        }

        .title {
          color: ${COLOR.PRIMARY};
          font-weight: 500;
          margin-bottom: 20px;
        }

        .wrapper {
          display: flex;
          justify-content: center;
        }

        .description {
          max-width: 360px;
          margin-bottom: 3rem;
        }
      `}</style>
      <Container content expand>
        <div className="wrapper">
          <div className="require-billing-info">
            <h3 className="title">Complete your billing information</h3>
            <div className="description">
              <p>
                <span>
                  According to our system, you currently don&apos;t have a
                  required billing information filled in your account. Please
                  provide a full billing address in our Billing Portal.
                </span>
              </p>
              <p>
                <span>
                  After completing the action click on &quot;Return to
                  Blockfrost.io&quot;. You will be redirected back to the
                  Dashboard. If you experience issues please&nbsp;
                </span>
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    window.$zopim.livechat.window.show();
                  }}
                >
                  contact our support
                </a>
                <span>.</span>
              </p>
            </div>

            <Link href={routes.billingPortal} passHref legacyBehavior>
              <a style={{ paddingTop: "0.25rem" }}>
                <Button type="submit">Proceed to Billing Portal</Button>
              </a>
            </Link>
          </div>
        </div>
      </Container>
    </>
  );
};

export default BillingAddressRequiredBanner;
